import React from 'react';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

// import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import * as appActions from '../../../../App/store/actions';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCookie, setCookie } from 'utils/cookies';
import { getUser } from '../../../../App/store/reducers';
import Utils from 'utils/utils';
import HamMenuIcon from 'images/svgs/Ham_menu.svg';
// import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { MobHeaderWrapper } from './MobHeader.styled';

const MobHeader = ({ onClickHamburger, logoutForUser, handleMenuClick, location }) => {
  const pageNameMapping = {
    '/portal/consigner': 'Consigner',
    '/portal/ticketing': 'Ticketing',
    '/portal/operator': 'Operator',
    '/portal/third-party': 'Third Party',
    '/portal/placement': 'Placement',
    '/portal/operations': 'Operations',
    '/portal/pod': 'POD',
    '/portal/invoice': 'Invoice',
    '/portal/create-demand': 'Create Demand',
    '/portal/update-vehicle': 'Update Vehicle',
    '/portal/nasdaq': 'Nasdaq',
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    logoutForUser();
    setCookie('email', '');
    setCookie('googleAuth', '');
    Utils.reAuthenticate();
    // props.history.push('/portal/login');
  };

  return (
    <MobHeaderWrapper>
      <div onClick={onClickHamburger}>
        <img src={HamMenuIcon} />
      </div>
      <Typography className="page-name" variant="h6">
        {pageNameMapping[location.pathname]}
      </Typography>
    </MobHeaderWrapper>
  );
};

function mapDispatchToProps(dispatch) {
  const logoutForUser = appActions.forUser.signOut;
  return bindActionCreators({ logoutForUser }, dispatch);
}

function mapStateToProps(state, props) {
  return {
    userInfo: getUser(state),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MobHeader));
